// Leyes / convenios bajo los que se contrata a un agente.
//
// Fuente única: la usan el select de convenios y el de agentes. Hoy es una lista fija;
// cuando RNHConvenioGet esté disponible, el catálogo real sale de ahí y esta constante
// queda solo como referencia de los códigos.
// La etiqueta es el numero solo, sin la palabra "Ley": el campo del formulario ya se
// llama "Ley" y la columna de la grilla tambien, asi que repetirla en cada opcion
// ("Ley 1904") es redundante.
export const LEYES = [
    { cod: "1904", label: "1904" },
    { cod: "1844", label: "1844" },
];

/**
 * Código -> etiqueta legible. Hoy son iguales, pero la función se mantiene por dos
 * motivos: es el único lugar donde tocar si alguna ley pasa a mostrarse distinto, y
 * si el código no está en la tabla devuelve el crudo, para no esconder un valor
 * inesperado del back.
 */
export const labelDeLey = (cod) =>
    LEYES.find((l) => l.cod === String(cod))?.label ?? (cod ?? "");
